import React, { useState } from "react";
import { TEXTS } from "../../constants";
import { Navigation } from "../../components/navigation";
import { useApp } from "../../context/AppContext";
import { DocumentLookup } from "../../components/lookup";
import { DocIcon, SecurityIcon, SignIcon } from "../../components/icons";
import {
  PageWrapper,
  ParticlesLayer,
  ContentWrapper,
  Title,
  Description,
  FeatureCards,
  FeatureCard,
  FeatureIconWrapper,
  FeatureTitle,
  FeatureDesc,
  CTASection,
  CTAContent,
  CTATitle,
  CTASubtitle,
  CTAButton,
  InfoSection,
  InfoTitle,
  StepsGrid,
  StepItem,
  StepNumber,
  StepText,
  Footer,
} from "./HomePage.styles";

function HomePage() {
  const { theme } = useApp();
  const isDark = theme === "dark";
  const [isLookupOpen, setIsLookupOpen] = useState(false); // Add state for modal

  // Specific colors directly in the component for better control over this specific look
  const colors = {
    purple: "#8b5cf6",
    green: "#10b981",
    orange: "#f59e0b",
  };

  return (
    <>
      <Navigation showBack={false} showHome={false} />

      {/* Lookup Modal */}
      <DocumentLookup
        isOpen={isLookupOpen}
        onClose={() => setIsLookupOpen(false)}
      />

      <PageWrapper $isDark={isDark}>
        <ParticlesLayer $isDark={isDark} />

        <ContentWrapper>
          <Title>{TEXTS.HOME.TITLE}</Title>
          <Description>{TEXTS.HOME.DESCRIPTION}</Description>

          <FeatureCards>
            <FeatureCard $isDark={isDark} $accentColor={colors.purple}>
              <FeatureIconWrapper
                $isDark={isDark}
                $bgDark="rgba(139, 92, 246, 0.1)"
                $bgLight="#f3e8ff"
                $color={colors.purple}
              >
                <DocIcon />
              </FeatureIconWrapper>
              <FeatureTitle $isDark={isDark}>קבלת מסמך</FeatureTitle>
              <FeatureDesc $isDark={isDark}>
                קבל קישור ייחודי ומאובטח ישירות לנייד שלך באמצעות SMS
              </FeatureDesc>
            </FeatureCard>

            <FeatureCard $isDark={isDark} $accentColor={colors.green}>
              <FeatureIconWrapper
                $isDark={isDark}
                $bgDark="rgba(16, 185, 129, 0.1)"
                $bgLight="#d1fae5"
                $color={colors.green}
              >
                <SecurityIcon />
              </FeatureIconWrapper>
              <FeatureTitle $isDark={isDark}>אימות זהות</FeatureTitle>
              <FeatureDesc $isDark={isDark}>
                מערכת אבטחה מתקדמת עם קוד אימות חד-פעמי להגנה מלאה
              </FeatureDesc>
            </FeatureCard>

            <FeatureCard $isDark={isDark} $accentColor={colors.orange}>
              <FeatureIconWrapper
                $isDark={isDark}
                $bgDark="rgba(245, 158, 11, 0.1)"
                $bgLight="#fef3c7"
                $color={colors.orange}
              >
                <SignIcon />
              </FeatureIconWrapper>
              <FeatureTitle $isDark={isDark}>חתימה מהירה</FeatureTitle>
              <FeatureDesc $isDark={isDark}>
                חתום על המסמכים שלך בקלות ובמהירות מכל מכשיר ובכל מקום
              </FeatureDesc>
            </FeatureCard>
          </FeatureCards>

          <CTASection $isDark={isDark}>
            <CTAContent>
              <CTATitle>יש לך מסמכים שממתינים?</CTATitle>
              <CTASubtitle>גש לאזור האישי כדי לצפות במסמכים שלך</CTASubtitle>
            </CTAContent>
            {/* Connected button to Modal State */}
            <CTAButton onClick={() => setIsLookupOpen(true)}>
              המסמכים שלי
            </CTAButton>
          </CTASection>

          <InfoSection $isDark={isDark}>
            <InfoTitle $isDark={isDark}>
              <span>💡</span>
              איך זה עובד
            </InfoTitle>

            <StepsGrid>
              <StepItem>
                <StepNumber $isDark={isDark}>1</StepNumber>
                <StepText $isDark={isDark}>{TEXTS.HOME.STEP_1}</StepText>
              </StepItem>
              <StepItem>
                <StepNumber $isDark={isDark}>2</StepNumber>
                <StepText $isDark={isDark}>{TEXTS.HOME.STEP_2}</StepText>
              </StepItem>
              <StepItem>
                <StepNumber $isDark={isDark}>3</StepNumber>
                <StepText $isDark={isDark}>{TEXTS.HOME.STEP_3}</StepText>
              </StepItem>
            </StepsGrid>
          </InfoSection>

          <Footer $isDark={isDark}>{TEXTS.HOME.FOOTER}</Footer>
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}

export default HomePage;
